import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import PurchasingStatisticsItem from '../entities/purchasing-statistics-item'
import Ajax from '../../lib/ajax'
import PageResult from '../entities/page-result';
import AppConsts from '@/lib/appconst'
interface PurchasingStatisticsState extends ListState<any> {
}
class PurchasingStatisticsModule extends ListModule<PurchasingStatisticsState, any, PurchasingStatisticsItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: AppConsts.pageSize,
        list: new Array<any>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<PurchasingStatisticsState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/PoReceipt/getAll-view', { params: payload.data });
            context.state.loading = false;
            const page = result;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    mutations = {
        setCurrentPage(state: PurchasingStatisticsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PurchasingStatisticsState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const purchasingStatisticsModule = new PurchasingStatisticsModule();
export default purchasingStatisticsModule;